import { useEffect, useState, useRef } from "react";
import { Field } from "formik";
import { Label } from "./Label";
import { useDate } from "./custom-hooks";
import AdmisionCursosSeleccionados from "./AdmisionCursosSeleccionados";
import PreviewImage from "../c&m/productos/PreviewImage";

const AdminDatosNuevo = ({
  //datosInscripcion,
  errors,
  Carnetvalidado,
  setFieldValue,
  values,
  onAction,
  FechaNace,
  datosFormNuevo,
  formatearFechaNacimiento,
  datosInscripcionStep1,
}) => {
  const convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  const fileRef = useRef(null);
  const [fechaNace, handleFechaNace] = useDate("FechaNace");
  const [fecha, setFecha] = useState(FechaNace);

  const handleSex = (e, setFieldValue) => {
    setFieldValue("Genero", e.target.value);
  };

  const handleFecha = (e, setFieldValue) => {
    handleFechaNace(e.target.value, setFieldValue);
    setFecha(e.target.value);
    onAction(e.target.value);
  };

  useEffect(() => {
    setFieldValue("FotoN", '')
    if (FechaNace !== "" || FechaNace !== undefined) {
      let anio = fecha.substring(0, 4); // ----####
      let mes = fecha.substring(4, 6); // ####--##
      let dia = fecha.substring(6, 8); // ######--
      let fechasinformato = `${anio}-${mes}-${dia}`;
      handleFechaNace(fechasinformato, setFieldValue);
    }

    // codigo para ver si los campos que el usuario estaba ingresando estan vacios o llenos

    if (!datosFormNuevo.hayData) {
      vaciarInputs();
      handleFechaNace("", setFieldValue);
    } else {
      persistirInputs();
    }
  }, [Carnetvalidado]); //idSeleccionado
 

  useEffect(() => {
    function handlePress(event) {
      if (document.activeElement.type === "text") {
        if (!`${event.target.value}${event.key}`.match(/^[A-Z|ÁÉÍÓÚ|a-z|áéíóú|\s]*$/)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }
    
    window.addEventListener("keypress", handlePress);
    return () => {
      window.removeEventListener("keypress", handlePress);
    };
  }, [])
  

  const vaciarInputs = () => {
    values.Apellidos = "";
    values.Nombres = "";
    values.ApellidosE = "";
    values.NombresE = "";
    values.ColAnterior = "";
    values.Cel = "";
    values.EmailE = values.Email; //hace uqe siempre tenga el correo configurado arriba
    values.FechaNace = "";
    setFieldValue("FechaNace", "");
    values.Genero = "";
  };

  const persistirInputs = () => {
    values.Apellidos = datosFormNuevo.Apellidos;
    values.Nombres = datosFormNuevo.Nombres;
    values.ApellidosE = datosFormNuevo.ApellidosE;
    values.NombresE = datosFormNuevo.NombresE;
    values.ColAnterior = datosFormNuevo.ColAnterior;
    values.Cel = datosFormNuevo.Cel;
    values.EmailE = values.Email; //hace uqe siempre tenga el correo configurado arriba
    values.FechaNace = formatearFechaNacimiento(values.FechaNace);
    values.Genero = datosFormNuevo.Genero;
  };

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="px-2 py-2 col-span-full lg:col-start-1 lg:col-end-2 rounded-lg bg-secundarioMira">
        <div className="mt-1 lg:col-span-3 lg:mt-0">
          <div className="py-2 sm:flex sm:items-start">
            
            <div className="flex w-full">
              <div className="flex basis-3/4">
                <div
                className="grid grid-rows-2">
              <h1 className="grid text-lg font-semibold text-white">Aspirante</h1>

              <p className="grid col-span-full mt-1 text-sm text-grisMira">Ingresa los datos del aspirante.</p>
                </div>
              
              </div>
            </div>
            <div className=" basis-1/4 shadow-xl h-full">
                <PreviewImage
                  file={values.FotoN}
                  className="h-[7.3rem] w-full object-cover rounded-t-lg"
                />
                <div className="w-full bg-azulBrillanteMira rounded-b-lg py-2 px-3">
                  <input
                    ref={fileRef}
                    type="file"
                    hidden
                    onChange={async (e) => {
                      const base64String = await convertBlobToBase64(
                        e.target.files[0]
                      );
                      setFieldValue("FotoN", base64String);
                    }}
                  />
                  <button
                    className="w-full text-white text-sm font-semibold hover:underline"
                    type="button"
                    onClick={() => {
                      fileRef.current.click();
                    }}
                  >
                    Agregar Fotografía
                  </button>
                  {errors?.FotoN && (
                        <div className="ml-4 text-sm font-medium text-secundario">
                          {errors?.FotoN}
                        </div>
                      )}
                </div>
              </div>
          </div>
          <div className="px-2 py-2 lg:grid  lg:grid-cols-2 gap-6 rounded-lg bg-secundarioMira border border-grisMira">
            <div className="col-span-full lg:col-start-1 lg:col-end-1 row-start-1">
              <Label lbl="Nombres" field="Nombres" />
              <Field
                type="text"
                name="Nombres"
                placeholder="Nombres del aspirante"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-6 lg:col-start-2 lg:col-end-2 row-start-1">
              <Label lbl="Apellidos" field="Apellidos" />
              <Field
                type="text"
                name="Apellidos"
                placeholder="Apellidos del aspirante"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-full lg:col-start-1 lg:col-end-1 row-start-2">
              <Label lbl="Fecha de nacimiento" field="FechaNace" />
              <div>
                <Field
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm "
                  type="date"
                  //max="2020-01-01"
                  //name="FechaNace"
                  value={fechaNace}
                  //value={(fechaNace == '')?fecha:fechaNace}
                  onChange={(e) => {handleFecha(e, setFieldValue)}}
                ></Field>
              </div>
            </div>
            <div className="col-span-6 lg:col-start-2 lg:col-end-2 row-start-2">
              <Label lbl="Colegio Anterior" field="ColAnterior" />
              <Field
                type="text"
                name="ColAnterior"
                placeholder="Colegio anterior"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-full lg:col-start-1 lg:col-end-1 row-start-3">
              <Label lbl="Género" field="Genero" />
              <div>
                <span className="text-sm text-white">
                  Masculino
                </span>
                <input
                  type="radio"
                  className="ml-1 mr-2 text-salmon cursor-pointer"
                  value="M"
                  onChange={(e) => handleSex(e, setFieldValue)}
                  checked={values.Genero === "M"}
                />
                <span className="text-sm text-white">Femenino</span>
                <input
                  type="radio"
                  className="ml-1 text-salmon cursor-pointer"
                  value="F"
                  onChange={(e) => handleSex(e, setFieldValue)}
                  checked={values.Genero === "F"}
                />
              </div>
            </div>
            <div className="">

            </div>
          </div>

          <br></br>

          <div className="py-2 sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-lg font-semibold text-white">Encargado</h1>
              <p className="mt-1 text-sm text-grisMira">
                Ingresa los datos del encargado.
              </p>
            </div>
          </div>

          <div className="px-2 py-2 lg:grid  lg:grid-cols-2 gap-6 rounded-lg bg-secundarioMira border border-grisMira">
            <div className="col-span-6 lg:col-start-2 lg:col-end-1 row-start-1">
              <Label lbl="Nombres del encargado" field="NombresE" />
              <Field
                type="text"
                name="NombresE"
                placeholder="Nombres"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-full lg:col-start-2 lg:col-end-2 row-start-1">
              <Label lbl="Apellidos del encargado" field="ApellidosE" />
              <Field
                type="text"
                name="ApellidosE"
                placeholder="Apellidos"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-6 lg:col-start-1 lg:col-end-1 row-start-2">
              <Label lbl="Correo electrónico" field="EmailE" />
              <Field
                type="email"
                name="EmailE"
                placeholder="correo@ejemplo.com"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
            <div className="col-span-full lg:col-start-2 lg:col-end-2 row-start-2">
              <Label lbl="Celular" field="Cel" />
              <Field
                type="number"
                name="Cel"
                minlength="8"
                maxLength="8"
                placeholder="00000000"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              ></Field>
            </div>
          </div>
        </div>
      </div>
      <div className="flex  rounded-lg  sm:h-[100%] lg:h-[50%] col-span-2 lg:col-span-1">
        <AdmisionCursosSeleccionados
          //datosInscripcion={datosInscripcionStep1.IdGrado == undefined ? datosInscripcion: datosInscripcionStep1}
          datosInscripcion={datosInscripcionStep1}
          color={"bg-secundarioMira"}
        />
      </div>
    </div>
  );
};

export default AdminDatosNuevo;
